var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCirclePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8327 14.8262H14.8257V19.8332H13.173V14.8262H8.16602V13.1734H13.173V8.1665H14.8257V13.1734H19.8327V14.8262Z",
    fill: "#2D49FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9993 25.6665C20.4427 25.6665 25.666 20.4432 25.666 13.9998C25.666 7.55651 20.4427 2.33317 13.9993 2.33317C7.55603 2.33317 2.33268 7.55651 2.33268 13.9998C2.33268 20.4432 7.55603 25.6665 13.9993 25.6665ZM13.9993 26.8332C21.087 26.8332 26.8327 21.0875 26.8327 13.9998C26.8327 6.91218 21.087 1.1665 13.9993 1.1665C6.91169 1.1665 1.16602 6.91218 1.16602 13.9998C1.16602 21.0875 6.91169 26.8332 13.9993 26.8332Z",
    fill: "#2D49FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlus);
export default __webpack_public_path__ + "static/media/CirclePlus.6a5339a4.svg";
export { ForwardRef as ReactComponent };